import { useMutation } from 'react-query';
import {useWordPressStore} from "../../store/wordpress.store";
import {WordpressApi} from "../../api/wordpress.api";

export const useWordPressFilesToDownload = () => {
    const setFilesToDownload = useWordPressStore((state) => state.setFilesToDownload);

    return useMutation(WordpressApi.getFilesToDownload, {
        onSuccess: (data) => {
            setFilesToDownload(data);
        },
        onError: (error) => {
            console.error('Login failed:', error);
        },
    });
};